export const StaticFields = {
    CurrencySymbol: "$",
    BearerOAuthToken: "Bearer q0HtS50_R",
    //OAuthToken: "Bearer _vAsBwSImtJLKGd9R85jTQMR6Lj8DvHD5CX5FmZ7Ci34TKextxsp4OSJ1GnxmGnx5jvt6Oux0SvhN_D4VWJqFXV-q6Z9sl8esl2XLtsDqRD7m9TWfadR20FWvECf_6ZVg_b05qCiSIW5j-ecN8U7xbVS34DQ3Izkv2eX09JnrkvD9rYcn7SNyJA_1i_hPMQ2AfkgXCJx8gBFg60gpDsafi2ezre3JB4g6kFY52C5z4R0g-YUhKo6LIplg8050VP0PPyJdClUO0nkZwetNRFKJTz4KD0Ab6JkbzUhsfg0ZV8sF2uoY",
    //APIDomain: "https://s8onlineorderweborder26bt96.s8app.com/api/",
    //Domain: "https://s8onlineorderweborder26bt96.s8app.com/",
    OAuthToken: "e9278e3cb6fe4f358a23aff0135da01a",
    APIDomain: "https://s8apimanagement.azure-api.net/api/", // Local - Web Ordering (S8Dev Brand)
    Domain: "https://s8apimanagement.azure-api.net/", // Local - Web Ordering (S8Dev Brand)
    //APIDomain: "https://s8oostagingdeployment000fnuv.s8app.com/api/",//"https://s8oostagingdeployment000fnuv.s8app.com/api/", // Staging - Web Ordering (S8Dev Brand)
    //Domain: "https://s8oostagingdeployment000fnuv.s8app.com/",//"https://s8oostagingdeployment000fnuv.s8app.com/", // Staging - Web Ordering (S8Dev Brand)
    //TyroDomain: "https://s8onlineorderweborder26bt96.s8app.com/",
    AppDomain: "https://weborderingbrooklyndonutsau.s8app.com", // Hosted build domain - used for payment page redirects (e.g. TyroPay.html) in both standalone and injection mode
    BrandUID: "E935F84D-802D-403F-9229-28DEEF82C57E", //S8DEMO = 9A9ADB74-A52B-4BC9-8A2B-8A2C14E6F77D, S8DEV = 7654380A-D18F-46A1-B151-64F7FB021EF8, Brooklyn = E935F84D-802D-403F-9229-28DEEF82C57E, KoalaKafe = A81CFAAD-BE79-4B9C-9155-E29E65DE6182, ChristophersCakes = FDB077BA-F8B7-4F29-8296-61289E453F80
    BrandCode: "492435", // S8DEMO = 220443, S8Dev = 690345, Brooklyn = 492435, Pattison = 625310, KOALAKEFE = 883202, CHRISTOPHERSCAKES = 369859
    EnableDoorDashWhiteLabelDelivery: false,
    EnableBrandLoyalty: false,
    ShowModifierImages: false,
    ShowCalendar: true,
    HideKitchenNotes: false,
    PickupMenuType: 'webordering',//'webordering', // app (pos needs to be online) / webordering (catering [pos does not need to be online])
    DeliveryMenuType: '', // delivery
    PriceType: 'bp8826', // bp8826 = bulk pricing
    OffsetStartTimeByMinutes: 60, // '' = no offset / Number = increase start time by minutes
    CateringNextDayCutoffTime: '15:00' // Catering next-day cutoff (browser-local time). After this time the earliest pickup day rolls forward 1 day. '' or absent = off.
}

export const GetCurrentDateTimeServerFormat = function () {
    const date = new Date();
    const dateString = `${date.getFullYear()}-${("00" + (date.getMonth() + 1)).slice(-2)}-${("00" + date.getDate()).slice(-2)}T${("00" + date.getHours()).slice(-2)}:${("00" + date.getMinutes()).slice(-2)}:${("00" + date.getSeconds()).slice(-2)}`
    return dateString;
}

export const RegexPatterns = {
    regexValidNameSpecialChar: /[^a-zA-Z0-9()%,.!$'-\s]/,
    regexMobile: /^04\d{8}$/,
    regexLandline10Char: /^0[^4]\d{8}$/,
    regexLandline8Char: /^\d{8}$/,
    regexEmail: /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,10}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,10})(\]?)$/
}

export function formatDisplayPrice(price) {
    let priceToDisplay = "";
    if (price !== 0 && price !== "0") { // Not 0
        if ((price).toString().charAt(0) !== "") { // Not empty
            if ((price).toString().charAt(0) === "-") { // Negative Price
                priceToDisplay = "-" + StaticFields.CurrencySymbol + (parseFloat(price).toFixed(2)).toString().slice(1); // Removes additional minus in original data
            } else {
                priceToDisplay = StaticFields.CurrencySymbol + parseFloat(price).toFixed(2);
            }
        } else {
            priceToDisplay = "";
        }
    } else {
        priceToDisplay = "";
    }
    return priceToDisplay
}